import { render, staticRenderFns } from "./collegeRule.vue?vue&type=template&id=b117e57a&scoped=true&"
import script from "./collegeRule.vue?vue&type=script&lang=js&"
export * from "./collegeRule.vue?vue&type=script&lang=js&"
import style0 from "./collegeRule.vue?vue&type=style&index=0&id=b117e57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b117e57a",
  null
  
)

export default component.exports